import t from "classnames";
import o, { forwardRef as n } from "react";
import { TypographyComponent as s } from "../typography/typography-component.esm.js";
import { text as _ } from "./config.esm.js";
const c = "_promoIdentifier_gcxn1_1", l = "_promoIdentifier__text_gcxn1_18", r = {
  promoIdentifier: c,
  promoIdentifier__text: l
}, x = n(({ color: i = "black", className: m, dataTestId: f, size: e = "l", children: p, ...a }, d) => /* @__PURE__ */ o.createElement(
  "div",
  {
    ref: d,
    className: t(r.promoIdentifier, m, "fuse-promo-identifier"),
    "data-color": i,
    "data-testid": f || "fuse-promo-identifier-test-id",
    ...a
  },
  /* @__PURE__ */ o.createElement(
    s,
    {
      className: t(r.promoIdentifier__text, "fuse-promo-identifier__text"),
      "data-testid": "fuse-promo-identifier__text",
      size: typeof e == "object" ? e : _.size[e] || { xxs: "m2", m: "m1", l: "1" },
      type: "paragraph"
    },
    p
  )
));
x.displayName = "PromoIdentifier";
export {
  x as PromoIdentifier
};
